import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Row, Col, Avatar, Space, Typography, Popover, Tooltip } from "antd";
import { Link } from "react-router-dom";
import styled from "styled-components";
import ContentBody from "../../CustomComponents/ContentBody";
import SearchBar from "../SearchBar";
import AppDrawer from "./AppDrawer";
import Logo from "../../Assets/proactive_logo.svg";
import { AppContext, UserContext } from "../Context";
import { styles, colorCodes } from "../../Styles/index";
import useQuery from "../../Utils/useQuery";
import { QuestionCircleOutlined } from "@ant-design/icons";
import BetaTag from "../../Styles/Components/BetaTag";
import {
  getUserContent,
} from "../../Utils/getData";

import "./hamburgers/customizedHamburgers.scss";

const { Text } = Typography;

const Title = styled(Text)`
  font-size: ${styles.headerTitleCopy};
`;

const CopyContainer = styled(Row)`
  margin-top: 64px;
  margin-bottom: 32px;
  .ant-col {
    margin-bottom: 10px;
  }
`;

const HelpText = styled(Text)`
  font-style: italic;
`;

export const WhiteBG = styled.div`
  background: #fff;
  padding: 26px 0;
  img.logo {
    max-width: 188px;
  }
  &.isHome {
    background-color: #d4e9c3;
  }
  min-height: 44px;
`;
const RightAlignCol = styled(Col)`
  text-align: right;
`;

const SearchContainer = styled.div`
  min-width: 300px;
`;

const LogoContainer = styled(Col)`
  display: flex;
  a {
    margin: auto 0;
  }
`;

const Hamburger = styled.div`
  width: 20px;
  height: auto;
  margin-top: 4px;
  margin-left: -20px;
`;

const Help = styled.div`
  width: 20px;
  height: auto;
  margin-top: 4px;
  margin-left: -5px;
`;

export interface IResourcesData {
  icon: string;
  name: string;
  value: string;
}

const ProactiveHeader = () => {
  const [isHome, setIsHome] = useState(false);
  const location = useLocation();
  const username = useContext(UserContext).value?.email;
  const isChannelPartner = useContext(UserContext).value?.role === "CP";
  const [avatarText, setAvatarText] = useState("A");
  const [avatarBackground, setAvatarBackground] = useState('#ccc');
  const DCPView = useQuery().get("view") === "DCP";
  const [appDrawerOpen, setAppDrawerOpen] = useState(false);
  const role = useContext(UserContext).value?.role || "";
  const type = useContext(UserContext).value?.type || "";
  const isImpersonate = useContext(UserContext).value?.impersonate;
  const DTAUrl = useContext(AppContext).value.dtaUrl;
  const [resources, setResources] = useState<IResourcesData[]>([]);

  useEffect(() => {
    if (location.pathname === "/") {
      setIsHome(true);
    } else {
      setIsHome(false);
    }
  }, [location]);

  useEffect(() => {
    const avatarText =
      username && username.length > 0 ? username.charAt(0).toUpperCase() : "A";
    setAvatarText(avatarText);
  }, [username]);

  useEffect(() => {
    if (isImpersonate) {
      setAvatarBackground('#ff4d4f')
    } else {
      setAvatarBackground('#ccc')
    }
  }, [isImpersonate]);

  useEffect(() => {
    if (role !== "CP") {
      getUserContent(type, role, "Resources").then((resources) => {
        setResources(resources);
      });
    }
  }, [type, role]);

  if (DCPView) {
    return <></>;
  }

  return (
    <WhiteBG className={isHome ? "isHome" : ""}>
      <ContentBody>
        <Row>
          <LogoContainer span={12}>
            <Link to="/">
              <img
                className="logo"
                src={Logo}
                alt="proactive logo"
                style={{ minHeight: "14px", width: "auto" }}
              />
            </Link>
          </LogoContainer>
          {(!isChannelPartner || isImpersonate === true) && (
            <RightAlignCol span={12}>
              <Space direction="horizontal" size="large">
                {!isHome && (
                  <SearchContainer>
                    <SearchBar />
                  </SearchContainer>
                )}
                <Help>
                  <Tooltip overlayStyle={{ whiteSpace: 'pre-line' }} title="Proactive Portal Help Center">
                    <a
                      href="https://illumina.gitbook.io/proactiveportal/"
                      target="_blank"
                    >
                      <QuestionCircleOutlined style={{ fontSize: '20px', color: `${colorCodes["textGrey"]}` }}/>
                    </a>
                  </Tooltip>
                </Help>
                <Popover
                  content={<AppDrawer control={setAppDrawerOpen} DTAUrl={DTAUrl} resources={resources} />}
                  trigger={"click"}
                  visible={appDrawerOpen}
                  onVisibleChange={setAppDrawerOpen}
                  title="Tools"
                >
                  <Hamburger
                    className={`hamburger hamburger--slider ${
                      appDrawerOpen ? "is-active" : ""
                    }`}
                    // onClick={() => setAppDrawerOpen(!appDrawerOpen)}
                  >
                    <span className="hamburger-box">
                      <span className="hamburger-inner"></span>
                    </span>
                  </Hamburger>
                </Popover>
                <Avatar style={{ backgroundColor: avatarBackground }}>{avatarText}</Avatar>
                </Space>
            </RightAlignCol>
          )}
        </Row>
        {isHome && (
          <CopyContainer>
            <Col xl={12} md={10} sm={24}>
              <Title>Welcome to the Illumina Proactive Portal!</Title>
              <br />
              <br />
              <Text>
                Try the easy search for connected accounts, instruments and much more
              </Text>
            </Col>
            {!isChannelPartner && (
              <Col xl={{span: 8, push: 4}} md={{span: 10, push: 4}} sm={24} xs={24}>
                <SearchContainer>
                  <SearchBar />
                </SearchContainer>
                <HelpText>try Bloomington, or A00114</HelpText>
              </Col>
            )}
          </CopyContainer>
        )}
      </ContentBody>
    </WhiteBG>
  );
};

const FooterRow = styled(Row)`
  height: 40vh;
  a {
    display: block;
    margin-bottom: 2px;
  }
  ul {
    margin: 0px;
    padding: 0px 0px 0px 20px;
    color: ${colorCodes.textGreen};
  }
`;

export const ProactiveFooter = () => {
  const role = useContext(UserContext).value?.role;

  return (
    <ContentBody>
      <FooterRow>
        <Col span={6}>
          <img
            className="logo"
            src={Logo}
            alt="proactive logo"
            style={{ minHeight: "14px", width: "auto" }}
          />
        </Col>
        {role !== "" && role !== "CP" && (
          <Col span={6}>
            <p>HELP TOPICS</p>
            <a
              href="https://illumina.gitbook.io/proactiveportal/"
              target="_blank"
            >
              Proactive Portal Help Center
            </a>
            <a
              href="https://illumina.seismic.com/Link/Content/DCH8VqJ79TR8RG4FhgV7jPhfJ7gV"
              target="_blank"
            >
              Proactive Product Resources
            </a>
          </Col>
        )}
      </FooterRow>
    </ContentBody>
  );
};

export default ProactiveHeader;
